import axios from "axios";
import RefreshTokenAPI from "../modules/login/refreshTokenApi";

export default {
    namespaced: true,
    actions: {
        useRefreshToken() {
            const refreshToken = localStorage.getItem("refresh-token");
            const body = {
                refresh_token: refreshToken
            };            
            return RefreshTokenAPI.refreshToken(body);
        },
        resetTokens({ dispatch }, res) {
            console.log("resetToken-res:", res);
            const token = res.data.token;
            const refreshToken = res.data.refresh_token;
            localStorage.setItem("access-token", token); // store the token in localstorage
            localStorage.setItem("refresh-token", refreshToken); // store the refresh token in localstorage
            // set axios default headers
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/refresh-token.js